const INITIAL_STATE = {
  data: {},
  errors: {},
}

const deletePhoneNumber = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'DELETE_PHONE_NUMBER':
    return { ...state, ...INITIAL_STATE, data: action.data }
  case 'DELETE_PHONE_NUMBER_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};

export default deletePhoneNumber;
